/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, Menu, Typography } from '@neo4j-ndl/react';
import { Square2StackIconOutline } from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const Component = () => {
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Menu
        isOpen={isOpen}
        anchorRef={anchorEl}
        placement="bottom-start-top-start"
        onClose={(_event, _data) => {
          setIsOpen(false);
        }}
        htmlAttributes={{ id: 'custom-items-menu' }}
      >
        <Menu.Item
          title={
            <Typography variant="display">This can be any element</Typography>
          }
        />
        <Menu.Item title="Danger action 1" className="n-text-danger-text" />
        <Menu.Item
          title="Danger action 2"
          className="n-text-danger-text"
          leadingVisual={
            <Square2StackIconOutline className="n-text-danger-icon" />
          }
        />
        <Menu title="More actions" description="Some additional actions">
          <Menu.Item
            title="Danger action 3"
            className="n-text-danger-text"
            isDisabled={true}
          />
          <Menu.Item title="Danger action 4" className="n-text-danger-text" />
        </Menu>
      </Menu>
      <FilledButton
        onClick={() => setIsOpen(true)}
        ref={anchorEl}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        Open Menu (set with custom placement)
      </FilledButton>
    </>
  );
};

export default Component;
